import {LogLevel} from '@app/service/logger/logger.service';
import moment from 'moment';

/**
 * Build the log entry from the log type, message and log date
 */
export class LogEntry {
  // Public Properties
  message = '';
  level: LogLevel = LogLevel.Debug;
  extraInfo: any[] = [];
  logWithDate = true;

  private static formatParams(params: any[]): string {
    let ret: string = params.join(',');

    // Is there at least one object in the array?
    if (params.some(p => typeof p === 'object')) {
      ret = '';
      // Build comma-delimited string
      for (const item of params) {
        ret += JSON.stringify(item) + ',';
      }
    }

    return ret;
  }

  buildLogString(): string {
    let ret = '';

    if (this.logWithDate) {
      ret = moment(new Date()).format('ddd, MMM DD YYYY, hh:mm:ss a') + ' - ';
    }
    ret += 'Type: ' + LogLevel[this.level];
    ret += ' - Message: ' + this.message;
    if (this.extraInfo.length) {
      ret += ' - Extra Info: ' + LogEntry.formatParams(this.extraInfo);
    }

    return ret;
  }
}
